import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import "./index.css"

function Credenciais() {

    const navigate = useNavigate()
    const location = useLocation()

    const { search } = location
  
    const params = new URLSearchParams(search)
  
    const idProjeto = params.get("idProjeto")
    const grupo = params.get("grupo")
    const usuarioGesttor = params.get("usuarioGesttor")
    const organizacaoGesttor = params.get("organizacaoGesttor")
    const perfilGesttor = params.get("perfilGesttor")
    const token = params.get("token")
    const usuarioGesttorAvatar = params.get("usuarioGesttorAvatar")
    const organizacaoGesttorAvatar = params.get("organizacaoGesttorAvatar")


    useEffect(() => {

        const urlRedirectProjeto = () => {
        
            if (!idProjeto || !grupo || !perfilGesttor || !token || !usuarioGesttorAvatar || !organizacaoGesttorAvatar || !usuarioGesttor || !organizacaoGesttor) return navigate(`/auth`)

            const data = new Date()
            const validadeToken = new Date(data.getTime() + 60 * 60 * 4 * 1000)

            document.cookie = `authGesttor=${token}; expires=true ${validadeToken.toUTCString()}`

            localStorage.setItem('perfilGesttor', perfilGesttor)
            localStorage.setItem('usuarioGesttorAvatar', usuarioGesttorAvatar)
            localStorage.setItem('organizacaoGesttorAvatar', organizacaoGesttorAvatar)
            localStorage.setItem('usuarioGesttor', usuarioGesttor)
            localStorage.setItem("organizacaoGesttor", organizacaoGesttor)
            localStorage.setItem('authGesttor', 'true')

            if (grupo === "Desenvolvimento de Software") {
                return navigate(`/kanban?idProjeto=${idProjeto}&grupo=${grupo}`)
            }
            
            return navigate(`/desafios?idProjeto=${idProjeto}&grupo=${grupo}`)
        }

        urlRedirectProjeto()

        }, [grupo, idProjeto, navigate, organizacaoGesttorAvatar, perfilGesttor, token, usuarioGesttorAvatar, organizacaoGesttor, usuarioGesttor])

        return (
            <div className="credenciais-container">
            <div className="spinner" />
                <p>Processando credenciais...</p>
            </div>
        )
}

export default Credenciais;